<template>
<!--
PRK 2LKM4LCLCB252
-->

<van-popover :placement="popOverPlacement" v-model:show="showPopoverBtnRef" :actions="actions" >
  <template #reference>

<van-button @mouseover="showPopoverBtnRef = true" plain @mouseleave="showPopoverBtnRef = false"  @click="varShowPopUpDevis = true" class="btn-add-prk" size="small" type="primary">
  <van-icon name="plus" /> Devis
</van-button>

</template>
</van-popover>

<van-popup  closeable  v-model:show="varShowPopUpDevis" position="bottom" class="van-popup-choose" >

 <h3 class="align-center">Ajouter les configurations d'un devis au panier</h3>
 <van-field :disabled="LoadAddRefDisabled" v-model="numDevis" class="input_prk all_border_radius"  center clearable label="N° de devis" placeholder="N° de devis">
    <template #button>
      <van-button :disabled="LoadAddRefDisabled" @click="addRefDevis"  size="small" type="primary">Ajouter</van-button>
    </template>
  </van-field>
  <Spinner style="margin-top: 90px;" v-if="LoadAddRefDisabled"/>

</van-popup>



  <br/>
    </template>
    
    <script>
     import Spinner from '../../loader/Spinner.vue'
    export default {
      props: ['popOverPlacement'],
      components: {
        Spinner,
      },
      data() {
        return {
          
          actions : [
      { text: "Ajouter les configurations d'un devis au panier" },
    ],
          LoadAddRefDisabled : false ,
          showPopoverBtnRef : false ,
          varShowPopUpDevis: false,
           // numDevis : '113794-0' ,
            numDevis : '' ,

        }
      },
      mounted(){
       
      },
      computed: {
    
      },
      created() {
       
          },
      methods:{
        async addRefDevis(){ 
          this.LoadAddRefDisabled = true 
          var decoupeDevis =  this.numDevis.split("-");

          var requestRefIntoDevis=  await this.globalFunctionPrePanier.getReferenceIntoDevis(decoupeDevis[0] , decoupeDevis[1] , this )
      
          for (let i in requestRefIntoDevis) {
          this.refPrk =  requestRefIntoDevis[i].reference
          await this.globalFunctionPrePanier.ajoutPrkInPanier(this)
          // affiche 0, 1, 2, "toto" dans la console
            }
            this.varShowPopUpDevis = false
            this.LoadAddRefDisabled = false 
        

          
          /*
          this.LoadAddRefDisabled = true 
          await this.globalFunctionPrePanier.ajoutPrkInPanier(this)
          this.varShowPopUpDevis = false
          this.LoadAddRefDisabled = false
          */
        },
      }
    
       
    }
    
    </script>
    
    <style>
    
    </style>
    
    